import React from 'react';
import { IconButton, Stack, Typography } from '@mui/material';
import { useCurrentEditor, useEditorState } from '@tiptap/react';
import { TooltipWrapper } from '@/components/TiptapEditor/Toolbar';
import AddColumnIcon from '@/components/icons/AddColumnIcon';
import RemoveColumnIcon from '@/components/icons/RemoveColumnIcon';
import AddRowIcon from '@/components/icons/AddRowIcon';
import RemoveRowIcon from '@/components/icons/RemoveRowIcon';
import RemoveTableIcon from '@/components/icons/RemoveTableIcon';

// Markdown tables always have exactly one header row and can't merge cells,
// so there's no merge/split or header toggle, and the header row can't be removed or moved down.
const TableMenu = () => {
	const { editor } = useCurrentEditor();

	const { isActiveHeader } = useEditorState({
		editor,
		selector: (ctx) => ({
			isActiveHeader: ctx.editor?.isActive('tableHeader'),
		}),
	});

	const actions = [
		{
			title: 'Add column before',
			icon: <AddColumnIcon direction='left' />,
			run: () => editor.chain().focus().addColumnBefore().run(),
		},
		{
			title: 'Add column after',
			icon: <AddColumnIcon direction='right' />,
			run: () => editor.chain().focus().addColumnAfter().run(),
		},
		{
			title: 'Delete column',
			icon: <RemoveColumnIcon />,
			run: () => editor.chain().focus().deleteColumn().run(),
		},
		{
			title: 'Add row before',
			icon: <AddRowIcon direction='top' />,
			disabled: isActiveHeader,
			run: () => editor.chain().focus().addRowBefore().run(),
		},
		{
			title: 'Add row after',
			icon: <AddRowIcon direction='bottom' />,
			run: () => editor.chain().focus().addRowAfter().run(),
		},
		{
			title: 'Delete row',
			icon: <RemoveRowIcon />,
			disabled: isActiveHeader,
			run: () => editor.chain().focus().deleteRow().run(),
		},
		{
			title: 'Delete table',
			icon: <RemoveTableIcon />,
			run: () => editor.chain().focus().deleteTable().run(),
		},
	];

	return (
		<Stack
			direction='row'
			columnGap={1}
			useFlexGap
			alignItems='center'
			sx={{
				flexWrap: 'wrap',
				'& .MuiSvgIcon-root': {
					fontSize: '22px',
				},
			}}
		>
			{actions.map(({ title, icon, disabled, run }) => (
				<TooltipWrapper key={title} title={title}>
					<IconButton size='small' disabled={disabled} onClick={run}>
						{icon}
					</IconButton>
				</TooltipWrapper>
			))}
		</Stack>
	);
};

export default TableMenu;
